
import { SignageAdapterApi } from "@vacancorp/signage.adapter.api.vacanservice.com";
import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "place-card",
  props: {
    type: {
      type: String as PropType<"female" | "male" | "barrier-free" | "spacious" | "nursing" | "baby">,
      required: false,
    },
    vacancy: { type: Object as PropType<SignageAdapterApi.ResponseGetDisplayVacancy>, required: true },
    currentLanguage: { type: String, required: false },
    areaName: { type: String },
    placeCellData: Object,
    gender: { type: String, required: false },
    placeKey: { type: String, required: false },
    placeIdHash: { type: String, required: false },
  },
  computed: {
    isVacant(): boolean {
      return !["full"].includes(this.vacancy.status);
    },
    vacancyCount(): string {
      const count = this.vacancy.vacancyCountText.languageList.ja?.match(/\d+\/\d+/);
      return count ? count[0] : "";
    },
    genderType(): string {
      return this.type.replace(/-[A-Z]/g, "");
    },
    isLineFeed(): boolean {
      const text = this.placeCellData.nameI18n.languageList["ja"];
      // \r\n が含まれていなければ、9文字以上の場合にクラスを付与
      return !text.includes("\r\n") && text.length > 9;
    },
    wrapperClass() : String{
      return this.vacancy.status + " void ";
    }
  },
  mounted: function(){
    //console.log((this.vacancy.status));
    //console.log(this.gender);
  },
  methods: {
    encodeNewlineToHtml(name: any, currentLanguage: string) {
      const languageList = name.languageList;
      const localizedPlaceName = languageList[currentLanguage];
      const fallbackLanguage = name.fallbackLanguage;
      const fallbackName = languageList[fallbackLanguage];

      if (localizedPlaceName || localizedPlaceName !== undefined) {
        return localizedPlaceName.replace(/\r\n/g, "<br>");
      } else {
        if (fallbackName || fallbackName !== undefined) {
          return fallbackName.replace(/\r\n/g, "<br>");
        }
      }
    },
    formatStatus(genderType: any, value: any, status: any) {
      if (genderType !== "baby") {
        switch (value) {
          case "空きあり":
            return "空";
          default:
            return value;
        }
      } else {
        switch (status) {
          case "vacancy":
          case "vacant":
          case "crowded":
            return "貸出可";
          case "full":
            return "貸出不可";
          case "closed":
            return "利用不可";
          case "open":
            return "利用可";
          default:
            return value;
        }
      }
    },
  },
});
